
<div class="profile-container">
  <div class="">
    <div class="profile-content">    
      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <div class="search">
              <form autocomplete="off" >
                <input type="text" placeholder="search">
              </form>
              <i class="bi bi-search"></i>
            </div>
            <!-- <button data-toggle="modal" data-target="#deviceModal"><i class="bi bi-plus-lg"></i> Add</button> -->
            <div class="filter-icon">
              <!-- <i class="bi bi-funnel" title="Filter" (click)="toggleFilter()"></i> -->
              <i class="bi bi-arrow-clockwise" title="Refresh"></i>
            </div>
          </div>
        </div>
        <div class="row map-block">
          <div class="col-md-12 col-lg-12">
            <app-page-soon></app-page-soon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>